import React from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { exportElementPdf } from "./pagePdf";
import { cls } from "./ui";

/** Reusable "PDF" button: exports the given element (or the page's main area) as a branded PDF. */
export function PdfButton({ title, getRoot, rootSelector, publicMode = false, variant = "chrome", label = "PDF", className, testId = "pdf-export-btn" }) {
  const run = () => {
    const root = getRoot ? getRoot() : rootSelector ? document.querySelector(rootSelector) : null;
    const n = exportElementPdf(root, { title, publicMode });
    if (!n) toast.info("Nothing printable on this view yet");
  };
  if (variant === "chrome") {
    return (
      <button onClick={run} aria-label="Export this page as PDF" title="Export page as PDF"
        className={cls("text-white/85 hover:text-white p-2 rounded-sm hover:bg-white/15 transition-colors flex items-center gap-1 no-print", className)}
        data-testid={testId}>
        <FileDown className="w-5 h-5" /><span className="text-[11px] font-bold tracking-wide">PDF</span>
      </button>
    );
  }
  return (
    <button onClick={run} aria-label="Export as PDF" data-testid={testId}
      className={cls("inline-flex items-center gap-1.5 border border-slate-300 bg-white text-slate-700 text-sm font-medium px-3 py-1.5 rounded-sm hover:bg-slate-100 no-print", className)}>
      <FileDown className="w-3.5 h-3.5" /> {label}
    </button>
  );
}
